import React from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';

const MapLink = ({ address, city, state, zipCode, children, ...props }) => {
  const q = qs.stringify({ q: `${address} ${city} ${state} ${zipCode}` });
  return (<a
    href={`http://maps.google.com/maps/?${q}`}
    target="_blank"
    rel="noopener noreferrer"
    {...props}
  >{children}</a>);
};

MapLink.propTypes = {
  address: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  zipCode: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default MapLink;



// WEBPACK FOOTER //
// ./client/app/shared/components/MapLink/index.jsx